import { render } from "./VitalChekInfo.vue?vue&type=template&id=6133343c"
import script from "./VitalChekInfo.vue?vue&type=script&lang=js"
export * from "./VitalChekInfo.vue?vue&type=script&lang=js"

import "./VitalChekInfo.vue?vue&type=style&index=0&id=6133343c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__